import { Injectable } from '@angular/core';

import { CamLazyTranslationService } from '@camelot/translation';

@Injectable({
  providedIn: 'root',
})
export class CamTranslationCalendar extends CamLazyTranslationService {
  constructor() {
    super('calendar');
  }
}
